import React, {useState} from 'react';
import './BorderTable.css'
import { Spinner } from '../fLoader';

/**
 *@author [Ashish Jha]
 *
 * Simple Bordered Table with All classes
 */


function BorderTable({sortby=[], params, filters=[], freeze=false, rows, headers, title, onSearch, options, empty, colwidths=[], onSelect, selectionKeys = [], defaultHeaders, className}) {

    const [SortBy, setSortBy] = useState();
    const [Order, setOrder] = useState('asc');

    const [showFilters, setshowFilters] = useState();
    const [SelectedFilter, setSelectedFilter] = useState();
    const [SelectedItems, setSelectedItems] = useState([]);

    //Settings visible headers to default headers if available
    const [Headers] = useState(defaultHeaders?defaultHeaders:headers);

    const [setshowHeaders] = useState();

    const onFilter = (key,option)=>{
        if(key){
            let search = {...params[0]}
            search[key] = option
            params[1](search)
        }else{
            let search = {...params[0]}
            delete search[filters[showFilters].key]
            params[1](search)
        }
    }

    const onSort = (sort,order)=>{
        params[1](prev=>({...prev, sort: camelCase(sort), order}))
    }

    //Forming an array of headers index positions that are hidden/collapsed
    let COLLAPSED = []
    headers.forEach((head, index) => {
        if(!Headers.includes(head)&&head!==''){
            COLLAPSED.push(index)
        }
    });

    //Convert header to camelCase for API based sorting of columns
    function camelCase(str){
        var ans = str.toLowerCase();
        return ans.split(" ").reduce((s,c)=> s + (c.charAt(0).toUpperCase()+ c.slice(1) ));
    }

    const selectItem = (item, checked) => {
        if(selectionKeys.length){
            if(SelectedItems.includes(item)){
                let selection = SelectedItems.filter(row=>row!==item)
                setSelectedItems(selection)
                onSelect(selection)
            }else{
                setSelectedItems([...SelectedItems, item])
                onSelect([...SelectedItems, item])
            }
        }
    }

    return (
        <>
            <div className='mt4'>
                {
                    rows?
                        <div className='borderTable'>
                            {(title || options || onSearch) &&
                                <div className='top-bar'>
                                    {title&&<h4 className='mr2 mb3 flex align-center'>{title}</h4>}
                                    <div className='flex align-center'>
                                        {options&&<div className='mb3'>{options}</div>}
                                        {
                                            onSearch&&
                                            <div className='relative ml2 mb3'>
                                                <input onChange={e=>onSearch(e.target.value)} type='text' placeholder='Search' style={{padding:'0.5rem', paddingRight: '2rem', fontSize:'0.8rem', background: 'var(--theme-surface-color)',border:'1px solid var(--border-color)'}}/>
                                                <i className='fas fa-search absolute' style={{right:'0.75rem', top:'0.75rem', fontSize: '0.8rem'}}/>
                                            </div>
                                        }
                                    </div>
                                </div>
                            }
                            <div className='ledger'>
                                <table style={{tableLayout:'fixed',border: '1px solid #dddd'}} className={className}>
                                    <thead>
                                    <tr style={{background:'rgba(0, 0, 0, 0.03)'}}>
                                        {
                                            //Empty first header if checkbox functionality is ON
                                            onSelect &&selectionKeys.length?
                                            <th style={{width:"50px",border: '1px solid #dddd'}}>
                                                <input checked={SelectedItems.length && (SelectedItems.length === selectionKeys.filter(el => el).length)} onChange={(e)=>{
                                                    if(SelectedItems.length && (SelectedItems.length === selectionKeys.filter(el => el).length)){
                                                        setSelectedItems([])
                                                        onSelect([])
                                                    }else{
                                                        setSelectedItems(selectionKeys.filter(item => item))
                                                        onSelect(selectionKeys.filter(item => item))
                                                    }
                                                }} type='checkbox'/>
                                            </th>
                                            :<></>
                                        }
                                        {
                                            Headers.map((head,index)=>{
                                                return (
                                                    <th className={freeze&&index===0?'freeze':''} style={colwidths?{width:colwidths[index],border: '1px solid #dddd'}:{}} key={index}>
                                                        <div className='flex align-center justify-between'>
                                                            <div className='flex w-100 text-nowrap align-center' onClick={()=>{
                                                                if(sortby.includes(head)){
                                                                    if(SortBy===head){
                                                                        if(Order==='asc'){
                                                                            setOrder('desc');onSort(head, 'desc')
                                                                        }else{
                                                                            setOrder('asc');onSort(head, 'asc')
                                                                        }
                                                                    }else{
                                                                        setOrder('asc');setSortBy(head);onSort(head, 'asc')
                                                                    }
                                                                }
                                                            }} id={`header-${head.replace(' ','')}`}>
                                                                {head}
                                                                {sortby.includes(head)?SortBy===head?Order==='asc'?<i className='fa fa-sort-up ml1'/>:<i className='fa fa-sort-down ml1'/>:<i className='fa fa-sort ml1'/>:<></>}
                                                            </div>
                                                            {
                                                                //If Default headers are provides turn on Header Customization
                                                                defaultHeaders&&
                                                                <div onClick={()=>setshowHeaders(true)} className='customize'><i className='ml2 fas fa-cog'/></div>
                                                            }
                                                            {Object.keys(filters).includes(head)?
                                                                <div className='relative' onClick={()=>setshowFilters(head)}>
                                                                    <i className='fa fa-filter ml1'/>
                                                                    {
                                                                        showFilters===head&&
                                                                        <div className='filters FadeInDown-Effect absolute border pd2 rounded-md pd1'>
                                                                            <div className='flex align-center justify-between mb1'>
                                                                                <div className='text-small'>Filters</div>
                                                                                <h2 onClick={(e)=>{e.stopPropagation();setshowFilters(undefined)}}><i className='fas fa-times-circle'/></h2>
                                                                            </div>
                                                                            <div className='flex flex-wrap' style={{width:'100vh', maxWidth:300}}>
                                                                                {
                                                                                    filters[head].options.map((item,index)=>{
                                                                                        if(!item)
                                                                                        return <></>
                                                                                        return <div key={index}
                                                                                            onClick={()=>{
                                                                                                if(SelectedFilter===item){
                                                                                                    setSelectedFilter(undefined)
                                                                                                    onFilter(undefined)
                                                                                                }else{
                                                                                                    setSelectedFilter(item);onFilter(filters[head].key,item)
                                                                                            }}}
                                                                                            className={`${SelectedFilter===item?'chip-active':'chip'} rounded-sm text-nowrap text-center`} style={{minWidth:50,padding:'0.3rem 0.5rem', fontSize:'0.7rem'}}>{item}</div>
                                                                                    })
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                    }
                                                                </div>
                                                                :<></>
                                                            }
                                                        </div>
                                                    </th>
                                                )
                                            })
                                        }
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {
                                        rows.map((row, index)=>{
                                            return (
                                                <tr key={index} style={{background: onSelect&&selectionKeys.length&&SelectedItems.includes(selectionKeys[index])?'#f2f2f2':'transparent'}}>
                                                    {
                                                        onSelect&&selectionKeys.length?
                                                        selectionKeys[index]?
                                                        <td style={{border: '1px solid #dddd'}}><input checked={SelectedItems.includes(selectionKeys[index])} onChange={(e)=>selectItem(selectionKeys[index],e.target.checked)} type='checkbox'/></td>
                                                        :<td/>
                                                        :<></>
                                                    }
                                                    {
                                                        //Skipping items that have index stored in collapsed array
                                                        row.map((col,index)=>{
                                                            if(COLLAPSED.includes(index)){
                                                                return <></>
                                                            }
                                                            return <td style={{border: '1px solid #dddd'}}  className={freeze&&index===0?'freeze':''} key={index}>{col}</td>
                                                        })
                                                    }
                                                </tr>
                                            )
                                        })
                                    }
                                    </tbody>
                                </table>
                                {
                                    rows.length===0&&
                                    <div className="flex align-center justify-center pd2">
                                        <p>No Items Found</p>
                                    </div>
                                }
                            </div>
                        </div>
                        :<div className='mt5 w-100 h-100 flex center'><Spinner/></div>
                }
            </div>
        </>
    );
}

export default BorderTable;
